import React from 'react';

const Reason = () => {
  return (
    <section className="reason">
      <h2 className="sec_title">Ton Bébéを選ぶ理由</h2>
      <ul>
        <li>
          <div className="numb">
            <p>選ぶ理由<span>01</span></p>
          </div>
          <div className="cont">
            <h3>国内最大級のドナー登録数</h3>
            <p>
              Ton Bébéはドナー数7000人、ドニー数1000人を超える、国内最大級の精子提供マッチングサービスです。検査書類や本人確認書類を提出済みのドナーは800人以上！あなたの希望にマッチするドナーもきっと見つかります。
            </p>
          </div>
        </li>
        <li>
          <div className="numb">
            <p>選ぶ理由<span>02</span></p>
          </div>
          <div className="cont">
            <h3>強固な個人情報セキュリティ</h3>
            <p>
              Ton Bébé はセキュリティの国際規格である ISO 27001 取得済みの環境で運用されております。あなたの個人情報はもちろんのこと、Ton Bébéを利用していることを他人に知られることもありません。
            </p>
          </div>
        </li>
        <li>
          <div className="numb">
            <p>選ぶ理由<span>03</span></p>
          </div>
          <div className="cont">
            <h3>安心のプライベートメッセージ機能</h3>
            <p>
              Ton Bébé には、ドナーとドニーの間でのみやりとりできるプライベートメッセージ機能が搭載されています。LINEなど他のメッセージアプリや個人の連絡先を交換する必要はありません。
            </p>
          </div>
        </li>
      </ul>
    </section>
  );
}

export default Reason;
